module.exports = __webpack_public_path__ + "img/8.2a411726.png";